class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      if (section.id === 'cart-drawer') {
        const cartDrawerEl = this.getSectionDOM(parsedState.sections[section.id], section.selector);
        const isCartEmpty = cartDrawerEl.closest("cart-drawer").classList.contains('is-empty');

        if (this.classList.contains("is-empty") === isCartEmpty) {
          this.classList.toggle('is-empty', isCartEmpty);

          const cartRecommendationsEl = document.querySelector('cart-recommendations');
          const cartDrawerForm = document.getElementById('CartDrawer-Form');
          const drawerFooterEl = document.querySelector('.drawer__footer');

          const newCartRecommendationsEl = cartDrawerEl.querySelector("cart-recommendations");
          const newCartDrawerFormEl = cartDrawerEl.querySelector("#CartDrawer-Form");
          const newDrawerFooterEl = cartDrawerEl.querySelector('.drawer__footer');

          cartRecommendationsEl.replaceWith(newCartRecommendationsEl);
          cartDrawerForm.replaceWith(newCartDrawerFormEl);
          drawerFooterEl.replaceWith(newDrawerFooterEl);

          const rewardBarEl = document.querySelector('cart-progress-bar');
          const newRewardBarEl = cartDrawerEl.querySelector('cart-progress-bar');
          rewardBarEl.dataset.cartTotal = newRewardBarEl.dataset.cartTotal;
          rewardBarEl.dataset.hasGift = newRewardBarEl.dataset.hasGift;

          const rewardBarValueEl = document.querySelector('.drawer__progress-bar-value');
          const newRewardBarText = cartDrawerEl.querySelector('.drawer__progress-bar-text').innerHTML;
          const rewardBarTextEl = document.querySelector('.drawer__progress-bar-text');
          const newRewardBarValueWidth = cartDrawerEl.querySelector('.drawer__progress-bar-value').style.width;
          rewardBarValueEl.style.width = newRewardBarValueWidth;
          const rewardPointsElems = document.querySelectorAll('.drawer__progress-bar-point');
          const newRewardPointsElems = cartDrawerEl.querySelectorAll('.drawer__progress-bar-point');

          rewardPointsElems.forEach((el, index) => {
            el.classList.toggle('point-active', newRewardPointsElems[index].classList.contains('point-active'));
          })

          rewardBarTextEl.innerHTML = newRewardBarText;
          rewardBarEl.triggerCartUpdate();
          return;
        } else {
          this.classList.toggle('is-empty', isCartEmpty);
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);

          if (!sectionElement) return;
          sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          return;
        }
      }

      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.handleAddRecommendation = this.handleAddRecommendation.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleAddRecommendation);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleAddRecommendation);
  }

  async handleAddRecommendation(e) {
    const addRecommendtionButtonEl = e.target.closest('.js-add-recommendation');
    if (!addRecommendtionButtonEl) return;

    addRecommendtionButtonEl.disabled = true;

    const itemEl = addRecommendtionButtonEl.closest('.drawer__recommendation-item');
    const variantId = itemEl.dataset.variantId;
    
    if (!variantId) {
      addRecommendtionButtonEl.disabled = false;
      return;
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!response.ok) throw new Error('Failed to add to cart');

      const cartDrawerEl = document.querySelector('cart-drawer');
      if (cartDrawerEl && typeof cartDrawerEl.renderContents === 'function') {
        const sectionsResponse = await fetch('/?sections=cart-drawer,cart-icon-bubble');
        const sectionsData = await sectionsResponse.json();
        cartDrawerEl.renderContents({ sections: sectionsData });
      }
    } catch (error) {
      console.error('Error adding product to cart:', error);
    } finally {
      button.disabled = false;
    }
  }
}

customElements.define('cart-recommendations', CartRecommendations);

class CartProgressBar extends HTMLElement {
  constructor() {
    super();
    this.giftProductVariantId = this.dataset.giftVariantId;
    this.giftPrice = parseInt(this.dataset.giftPrice, 10);
    this.cartTotal = parseInt(this.dataset.cartTotal, 10) || 0;
    this.hasGift = this.dataset.hasGift === 'true';
    this.isProcessingGift = false;
    this.handleCartChange = this.handleCartChange.bind(this);
  }

  connectedCallback() {
    this.observeCart();
    this.checkGiftProduct();
  }

  disconnectedCallback() {
    document.removeEventListener('cart:updated', this.handleCartChange);
  }

  observeCart() {
    document.addEventListener('cart:updated', this.handleCartChange);
  }

  async handleCartChange() {
    this.cartTotal = parseInt(this.dataset.cartTotal, 10) || 0;
    this.hasGift = this.dataset.hasGift === 'true';
    await this.checkGiftProduct();
  }

  async checkGiftProduct() {
    if (this.isProcessingGift) return;

    const shouldAddGift = this.cartTotal >= this.giftPrice && !this.hasGift;
    const shouldRemoveGift = this.cartTotal < this.giftPrice && this.hasGift;

    if (shouldAddGift) {
      this.isProcessingGift = true;
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: this.giftProductVariantId, quantity: 1, sections: 'cart-drawer,cart-icon-bubble' }),
      });
      const data = await res.json();

      await this.updateCartDrawerSections(data.sections);
      this.isProcessingGift = false;
    } else if (shouldRemoveGift) {
      this.isProcessingGift = true;
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: this.giftProductVariantId, quantity: 0, sections: 'cart-drawer,cart-icon-bubble' }),
      });
      const data = await res.json();

      await this.updateCartDrawerSections(data.sections);
      this.isProcessingGift = false;
    }
  }

  async updateCartDrawerSections(sectionsData) {
    const cartDrawerEl = document.querySelector('cart-drawer');
    
    if (cartDrawerEl && typeof cartDrawerEl.renderContents === 'function') {
      cartDrawerEl.renderContents({ sections: sectionsData });
    }
  }

  triggerCartUpdate() {
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }
}

customElements.define('cart-progress-bar', CartProgressBar);
